import { SmartphotoStatus as Status } from '@bdeo-motor/smartphoto-entities';
export { SmartphotoStatus as Status } from '@bdeo-motor/smartphoto-entities';

export type StatusMap = { [key in Status]: string };

export const StatusLang: StatusMap = {
  0: 'new',
  1: 'in_progress',
  2: 'completed',
  3: 'cancelled',
  5: 'reviewed',
  6: 'reopened',
  7: 'reopened_by_workshop',
  8: 'repaired'
};

export const StatusColor: StatusMap = {
  0: 'old-sun',
  1: 'mango-mojito',
  2: 'guacalime',
  3: 'red-velvet',
  5: 'sick-alien',
  6: 'mango-mojito',
  7: 'guacalime',
  8: 'sick-alien'
};

export const StatusIcon: StatusMap = {
  0: 'status-nuevo',
  1: 'status-en-curso',
  2: 'status-pendiente-revision',
  3: 'status-cancelado',
  5: 'status-revisado',
  6: 'status-en-curso',
  7: 'status-pendiente-revision',
  8: 'status-reparado'
};
